import {
  CertificationAndLicense,
  CertsAndLicenseEdit,
} from '@dispatch/shared/types';
import { SearchField, tableStyleOverrides, textColumn } from '@dispatch/web/ui';
import { Box, Stack } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import React from 'react';
import { isRunningInJest } from '@dispatch/testing';
import { grey } from '@mui/material/colors';

export const CertsAndLicenseModalList = ({
  searchByName,
  tableData,
  setEditData,
}: {
  searchByName: (value: string) => void;
  tableData: CertificationAndLicense[];
  setEditData: React.Dispatch<CertsAndLicenseEdit>;
}) => {
  const certsCols: GridColDef[] = [
    {
      field: 'verificationType',
      headerName: 'Type',
      renderCell: (params: GridRenderCellParams) => (
        <span
          data-testid="cert-type-link"
          style={{ fontWeight: '600', cursor: 'pointer' }}
          onClick={() => setEditData({ ...params?.row, mode: 'assign' })}
        >
          {params?.row?.verificationType}
        </span>
      ),
    },
    textColumn({
      field: 'name',
      headerName: 'Name',
    }),
    textColumn({
      field: 'description',
      headerName: 'Description',
    }),
    textColumn({
      field: 'organization',
      headerName: 'Organization',
    }),
    textColumn({
      field: 'expirationDate',
      headerName: 'Require Exp. Date',
      valueGetter: (params) => (!params?.row?.expirationDate ? 'Yes' : 'No'),
    }),
  ];

  return (
    <Stack justifyContent="space-between" height="550px" p={2}>
      <Stack
        data-testid="cert-modal-list"
        direction="row"
        alignItems="center"
        justifyContent="right"
      >
        <SearchField
          backgroundColor={grey[50]}
          searchIconColor={grey[900]}
          clearButtonColor={grey[900]}
          textColor={grey[900]}
          onSearch={searchByName}
        />
      </Stack>
      <Box height={500} data-testid="certs-list">
        <DataGridPro
          disableVirtualization={isRunningInJest()}
          sx={tableStyleOverrides}
          rows={tableData || []}
          columns={certsCols}
          rowHeight={38}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
          disableSelectionOnClick
        />
      </Box>
    </Stack>
  );
};
